// import 'babel-polyfill';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import 'bootstrap/dist/css/bootstrap-reboot.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.min.css';
import BootstrapVue from 'bootstrap-vue';
import { range } from 'lodash';
import VueLodash from 'vue-lodash';
import VueCookies from 'vue-cookies';
import vueMoment from 'vue-moment';
import VueSanitize from 'vue-sanitize';
import App from './App.vue';
import router from './router';
import store from './store';
import Vue2TouchEvents from 'vue2-touch-events'; /* 터치 스와이프(뉴스, 라이브러리 상세 페이지 적용) */

Vue.use(BootstrapVue);
Vue.use(VueLodash, { lodash: { range } });
Vue.use(VueCookies);
Vue.use(vueMoment);
Vue.use(Vue2TouchEvents);

Vue.$cookies.config('1d'); // 쿠키 기본만료일 1일로 셋팅

Vue.config.productionTip = false;
const sanitizeOption = {
  allowedTags: [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'ul', 'li', 'div',
    'span', 'img', 'b', 'table', 'tr', 'td', 'tbody', 'thead', 'th', 'br',
    'i', 'a', 'font', 'hr', 'strong', 'ol', 'u', 'figure',
  ],
  allowedAttributes: {
    '*': [
      'href', 'style', 'class', 'id', 'width', 'border', 'cellspacing', 'cellpadding', 'rowspan', 'cellspan', 'src', 'face', 'color',
    ],
  },
};

Vue.use(VueSanitize, sanitizeOption);

new Vue({
  router,
  store,
  created() {
    // window.Kakao.init(`${process.env.VUE_APP_KAKAO_KEY}`);

  },
  render: (h) => h(App),
}).$mount('#app');
